"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContentIdsFromGroupIds = void 0;
const tslib_1 = require("tslib");
const contentQueryHelper_1 = require("./common/contentQueryHelper");
function getContentIdsFromGroupIds(filters) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const _source = { includes: ['_id'] };
        const contents = yield contentQueryHelper_1.loadContentsFromContentIds(filters, true, _source);
        return { contents, total: contents.length };
    });
}
exports.getContentIdsFromGroupIds = getContentIdsFromGroupIds;
//# sourceMappingURL=getContentIdsFromGroupIds.js.map